import React from 'react';
import useTextOverlayAdvancedAnimation from '../../../useTextOverlayAdvancedAnimation';
import AnimationColorSelector from '../../AnimationColorSelector';

export interface ActiveLineScrollAnimationFutureLineColorSelectorProps {}

const ActiveLineScrollAnimationFutureLineColorSelector: React.FC<ActiveLineScrollAnimationFutureLineColorSelectorProps> = () => {
  const {
    selectedAdvancedAnimation,
    onAnimationPropertyChange,
  } = useTextOverlayAdvancedAnimation();

  return (
    <AnimationColorSelector
      title="future line color"
      color={selectedAdvancedAnimation?.properties?.lineFutureColor}
      onChange={color => onAnimationPropertyChange('lineFutureColor', color)}
    />
  );
};

export default ActiveLineScrollAnimationFutureLineColorSelector;
